import { render, staticRenderFns } from "./CallCentersTable.vue?vue&type=template&id=5683f37c&scoped=true"
import script from "./CallCentersTable.vue?vue&type=script&lang=js"
export * from "./CallCentersTable.vue?vue&type=script&lang=js"
import style0 from "./CallCentersTable.vue?vue&type=style&index=0&id=5683f37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683f37c",
  null
  
)

export default component.exports